<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <!--        <div v-rblink="{name:'DakejianApply',query:{}}" style="padding: 10px;"> <img style="width: 100%; " src="https://cheeseman.oss-cn-hangzhou.aliyuncs.com/editor/20210308/user-0/20210308/caf9635f9db8148227664f87208f4c69.jpeg?x-oss-process=style/tb-750" /></div>-->
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>

          <van-field
              readonly
              v-if="false"
              clickable 
              v-show="formData.jindu!=6"
              :value="formData.extra_saiqu2.length ? formData.extra_saiqu2[0].name : ''"
              autosize
              type="textarea"
              input-align="right"
              label="可申请升级赛区"
              placeholder="点击选择已报名参赛的赛区"
              @click="showSaiquPicker2 = true"
          />
          <SaiquPicker
              :show="showSaiquPicker2"
              url="api/sai/clubSaiquOptions"
              :limit="1"
              :is_online="2"
              :value="formData.extra_saiqu2"
              @onChange="onSaiqu2Change"
              @onClose="showSaiquPicker2=false"
              :defaultValue="formData.extra_saiqu2"
              @onConfirm="onSaiqu2Confirm"
          ></SaiquPicker>

        <van-field
            readonly
            clickable
            :value="formData.extra_saiqu.length ? formData.extra_saiqu[0].name : ''"
            autosize
            type="textarea"
            input-align="right"
            label="线下领取牌匾的比赛名称"
            placeholder="点击选择领取的比赛名称"
            @click="showSaiquPicker = true"
        />
        <SaiquPicker
            :show="showSaiquPicker"
            url="api/sai/dakejianSaiquOptions"
            :limit="1"
            :is_online="2"
            :value="formData.extra_saiqu"
            @onChange="onSaiquChange"
            @onClose="showSaiquPicker=false"
            :defaultValue="formData.extra_saiqu"
            @onConfirm="onSaiquConfirm"
        ></SaiquPicker>
        
        <van-field
            readonly
            clickable
            name="year"
            :value="formData.year"
            input-align="right"
            label="申报年度"
            placeholder="点击选择申报年度"
            @click="() =>{
              formData.id?'':showDate = true
            }"
        />
        <van-popup v-model="showDate" position="bottom">
          <van-datetime-picker
              @cancel="showDate =false"
              title="选择年月"
              type="year-month"
              :default-date='new Date( (formData.year? formData.year :"" ).replace(/-/g,"/") )'
              :min-date="minDate"
              @confirm="onDateConfirm"/>
        </van-popup>

        <van-field name="radio" label="类型"
                   input-align="right">
          <template #input>
            <van-radio-group v-model="formData.type" direction="horizontal">
              <van-radio checked-color="#ffb01b" :name="1">全国校园大课间啦啦操推广示范单位</van-radio>
<!--              <van-radio checked-color="#ffb01b" :name="2">先进个人</van-radio>-->
            </van-radio-group>
          </template>
        </van-field>
        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="省市区"
            placeholder="点击选择省市区"
            @click="() =>{
              formData.id?'':showArea = true
            }"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>

        <van-field
            v-model="formData.danwei"
            :rules="[{ required: true, message: '单位名称不能为空' }]"
            label="单位名称"
            input-align="right"
            :disabled="formData.id>0"
            error-message-align="right"
            clearable
            placeholder="请输入单位名称"
        />
        <van-field
            v-model="formData.address"
            :rules="[{ required: true, message: '请输入详细地址' }]"
            error-message-align="right"
            label="详细地址"
            :disabled="formData.id>0"
            input-align="right"
            clearable
            placeholder="请输入详细地址"
        />

        <van-field
            v-model="formData.renshu"
            :rules="[{ required: true, message: '人数不能为空' }]"
            error-message-align="right"
            label="全校人数"
            :disabled="formData.id>0"
            type="number"
            input-align="right"
            clearable
            placeholder="请输入全校人数"
        />
                <!-- <div class="operate-desc-left"  >全校人数</div> -->



      </van-cell-group>

      <van-divider>先进个人（教师或校长信息）
      </van-divider>

      <van-cell-group>

        <van-field
            v-model="formData.jiaoshi_name"
            :rules="[{ required: true, message: '请输入姓名' }]"
            error-message-align="right"
            label="个人姓名（限一人）"
            :disabled="formData.id>0"
            input-align="right"
            clearable
            placeholder="请输入姓名"
        />


        <van-cell title="活动照片" :value="formData.huodongpic.length+'/5'">
        </van-cell>

        <div class="row">
          <PicUploader :fileList="formData.huodongpic" :limit="5"
                       :name="'huodongpic'"></PicUploader>
        </div>

                <div class="operate-desc-left" style="color:#F00;font-weight:bold">照片需要5张可以体现出全员啦啦操大课间照片哦</div>


      </van-cell-group>


      <van-divider>联系人信息</van-divider>

      <van-cell-group>

        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: '请输入姓名' }]"
            error-message-align="right"
            label="姓名"
            :disabled="formData.id>0"
            input-align="right"
            clearable
            placeholder="请输入姓名"
        />
<!--        <van-field-->
<!--            v-model="formData.zhiwu"-->
<!--            :rules="[{ required: true, message: '请输入校内职务' }]"-->
<!--            error-message-align="right"-->
<!--            label="校内职务"-->
<!--            input-align="right"-->
<!--            clearable-->
<!--            placeholder="请输入校内职务"-->
<!--        />-->


<!--        <van-field-->
<!--            v-model="formData.email"-->
<!--            :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"-->
<!--            error-message-align="right"-->
<!--            label="邮箱"-->
<!--            input-align="right"-->
<!--            clearable-->
<!--            placeholder="请输入邮箱"-->
<!--        />-->


        <van-field
            v-model="formData.phone"
            :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
            error-message-align="right"
            label="手机"
            input-align="right"
            clearable
            :disabled="formData.id>0"
            placeholder="请输入手机"
        />

      </van-cell-group>

<!--      <van-divider>校长信息-->
<!--      </van-divider>-->

<!--      <van-cell-group>-->

<!--        <van-field-->
<!--            v-model="formData.xiaozhang_name"-->
<!--            :rules="[{ required: true, message: '请输入姓名' }]"-->
<!--            error-message-align="right"-->
<!--            label="校长姓名"-->
<!--            input-align="right"-->
<!--            clearable-->
<!--            placeholder="请输入姓名"-->
<!--        />-->


<!--        <van-field-->
<!--            v-model="formData.xiaozhang_num"-->
<!--            :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"-->
<!--            error-message-align="right"-->
<!--            label="校长身份证号"-->
<!--            input-align="right"-->
<!--            clearable-->
<!--            placeholder="请输入身份证号"-->
<!--        />-->


<!--      </van-cell-group>-->

      <div style="height: 100px"></div>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          提交报名
        </van-button>
      </div>
    </van-form>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'DakejianApplySimple',
  components: {
    PicUploader, LoginDialog, SaiquPicker
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      showSaiquPicker: false,
      showSaiquPicker2: false,
      showArea: false,
      showDate: false,
      areaList: {},
      areaValue: '',
      submitType: '',

      minDate: new Date( ),
      formData: {
        id: 0,
        year: '',
        type: 1,
        address: '',
        huodongpic: [],
        extra_saiqu: [],
        extra_saiqu2: [],
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = '大课间申报'

    that.areaList = area;
    that.formData.id = this.$route.query.id;
    that.getUserDetail();
    if(that.formData.id){
    this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getUserDetail() {
      let that = this;
      this.$api.get('/api/user/userPage', {}, (res) => {
        console.log(res)
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        } else {
          Toast(res.msg)
        }
      })
    }, 
    fetch() {
      let that = this;
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      that.$api.post('/api/cdakejian/dakejianDetail', {
        id : that.formData.id,
      }, (res) => { 
        res.data.extra_saiqu = res.data.stationid>0? [{
          id:res.data.stationid,
          name:res.data.saiqu_name, 
        }]:[]
        res.data.extra_saiqu2 = res.data.stationid2>0? [{
          id:res.data.stationid2,
          name:'', 
        }]:[]
        that.formData = res.data;

        that.isLoading = false
        Toast.clear()
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    }, 
    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.extra_saiqu = [...values];
    },


    onSaiqu2Change(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu2 = [...values];
    },
    onSaiqu2Confirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker2 = false;
      this.formData.extra_saiqu2 = [...values];
    },

    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      // this.formData.datetitle =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
      this.formData.year =  `${date.getFullYear()}-${date.getMonth() + 1}`
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }

        if (!this.formData.huodongpic.length) {
          Toast.fail('请上传活动图片');
          return
        }
      }
      that.saveLoading = true;

      that.formData.stationid = that.formData.extra_saiqu.length ? that.formData.extra_saiqu[0].id :0
      that.formData.stationid2 = that.formData.extra_saiqu2.length ? that.formData.extra_saiqu2[0].id :0

      that.$api.post('/api/cdakejian/applySimple', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('提交成功');
        setTimeout(() => {
          // rbLink({
          //   name: "CDakejianApplySuccess",
          //   query: {
          //     id: res.data.id
          //   }
          // }, 'replace')

          rbLink({
            name: "",
          }, 'back')
        }, 200)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast(res.msg);
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// DakejianApplySimple.vue?3dfe4398